const DISCOUNT_MODAL_STORAGE_KEY = 'new-customer-discount-modal-shown-at'
const DISCOUNT_MODAL_STORAGE_DURATION = 30 * 24 * 60 * 60 * 1000

let discountModalTimeout = null
let discountModalOpened = false

const wasDiscountModalRecentlyShown = () => {
  try {
    const shownAt = Number(window.localStorage.getItem(DISCOUNT_MODAL_STORAGE_KEY))

    if (!Number.isFinite(shownAt) || shownAt <= 0) {
      return false
    }

    if (Date.now() - shownAt < DISCOUNT_MODAL_STORAGE_DURATION) {
      return true
    }

    window.localStorage.removeItem(DISCOUNT_MODAL_STORAGE_KEY)
  } catch (error) {
    console.error(error)
  }

  return false
}

const rememberDiscountModalShown = () => {
  try {
    window.localStorage.setItem(DISCOUNT_MODAL_STORAGE_KEY, String(Date.now()))
  } catch (error) {
    console.error(error)
  }
}

const showReopenButton = () => {
  document.querySelectorAll('[data-new-customer-discount-reopen]').forEach((button) => {
    button.classList.remove('d-none')
  })
}

const showDiscountModal = () => {
  const trigger = document.querySelector('[data-new-customer-discount-trigger]')

  if (!(trigger instanceof HTMLElement)) {
    return
  }

  trigger.click()
}

const openDiscountModalImmediately = () => {
  if (discountModalTimeout !== null) {
    window.clearTimeout(discountModalTimeout)
    discountModalTimeout = null
  }

  showDiscountModal()
}

export const openDiscountModal = () => {
  if (discountModalTimeout !== null || discountModalOpened || wasDiscountModalRecentlyShown()) {
    return
  }

  discountModalTimeout = window.setTimeout(() => {
    discountModalTimeout = null

    if (wasDiscountModalRecentlyShown()) {
      return
    }

    showDiscountModal()
  }, 30000)
}

const initEmailForm = () => {
  document.addEventListener('submit', async (event) => {
    const form = event.target

    if (!(form instanceof HTMLFormElement) || !form.matches('[data-new-customer-discount-email-form]')) {
      return
    }

    event.preventDefault()

    const button = form.querySelector('button[type="submit"]')
    const email = form.querySelector('input[type="email"]')
    const success = form.querySelector('[data-new-customer-discount-email-success]')
    const errorMessage = form.querySelector('[data-new-customer-discount-email-error]')

    if (!(button instanceof HTMLButtonElement) || !(email instanceof HTMLInputElement)) {
      return
    }

    button.disabled = true
    success?.classList.add('d-none')
    errorMessage?.classList.add('d-none')

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to send discount code: ${response.status}`)
      }

      email.disabled = true
      success?.classList.remove('d-none')
    } catch (error) {
      console.error(error)
      button.disabled = false
      errorMessage?.classList.remove('d-none')
    }
  })
}

const initReopenButton = () => {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return
    }

    const button = event.target.closest('[data-new-customer-discount-reopen]')

    if (!(button instanceof HTMLElement)) {
      return
    }

    openDiscountModalImmediately()
  })

  if (wasDiscountModalRecentlyShown()) {
    showReopenButton()
  }
}

const initModalState = () => {
  const modal = document.querySelector('[data-new-customer-discount-modal]')

  if (!(modal instanceof HTMLElement)) {
    return
  }

  modal.addEventListener('shown.bs.modal', () => {
    discountModalOpened = true
    rememberDiscountModalShown()
  })

  modal.addEventListener('hidden.bs.modal', showReopenButton)
}

export const initNewCustomerDiscount = () => {
  initEmailForm()
  initReopenButton()
  initModalState()
}

window.openDiscountModal = openDiscountModal
